var map = {
	"./black_che.png": 1267,
	"./black_jiang.png": 954,
	"./black_ma.png": 780,
	"./black_pao.png": 8939,
	"./black_shi.png": 8613,
	"./black_xiang.png": 9853,
	"./black_zu.png": 2805,
	"./chess_board.png": 4286,
	"./red_bing.png": 5081,
	"./red_che.png": 8274,
	"./red_ma.png": 3105,
	"./red_pao.png": 3336,
	"./red_shi.png": 3289,
	"./red_shuai.png": 16,
	"./red_xiang.png": 398
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9962;